import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "newlineToBr", pure: false })
@Injectable()
export class NewlineToBrPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\n/g, "<br>");
  }
}